module.exports = __webpack_public_path__ + "static/media/logo-sms.ac3d86d2.png";